import { render } from "./SplashScreenLoader.vue?vue&type=template&id=2e81f594&scoped=true"
import script from "./SplashScreenLoader.vue?vue&type=script&lang=js"
export * from "./SplashScreenLoader.vue?vue&type=script&lang=js"

import "./SplashScreenLoader.vue?vue&type=style&index=0&id=2e81f594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e81f594"]])

export default __exports__